/**
 * 定数.
 */
export class Constants {

  /** 一時保存情報のキー：グループ会社コードの固定値. */
  public static LOCAL_SAVE_KEY_GROUP_COMPANY_CODE = 'SLI';

  /** 共有データ保存のキー：過去日報一覧から、過去日報詳細に渡すデータ． */
  public static SHARED_DATA_SAVE_KEY_OLD_REPORT_PARAM = 'SHARED_DATA_SAVE_KEY_OLD_REPORT_PARAM';

  /** 共有データ保存のキー：Kvaw0300の取得結果. */
  public static SHARED_DATA_KEY_KVAW0300_API_RESULT = 'SHARED_DATA_KEY_KVAW0300_API_RESULT';

  /** 共有データ保存のキー：担当店一覧選択週. */
  public static SHARED_DATA_KEY_SELECTED_WEEK = 'SHARED_DATA_KEY_SELECTED_WEEK';
}



// WEBPACK FOOTER //
// ./src/app/constants/constants.ts